import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Home, User, Briefcase, FileText, Mail } from "lucide-react";
import INFO from "../../data/user";
import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	const location = useLocation();
	const [scrolled, setScrolled] = useState(false);
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 20) {
				setScrolled(true);
			} else {
				setScrolled(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// Determine active state from prop or current pathname
	const currentActive = active || (
		location.pathname === "/" ? "home" :
		location.pathname.startsWith("/about") ? "about" :
		location.pathname.startsWith("/projects") ? "projects" :
		location.pathname.startsWith("/article") ? "articles" :
		location.pathname.startsWith("/contact") ? "contact" : ""
	);

	return (
		<header className={`nav-container ${scrolled ? "scrolled" : ""}`}>
			<nav className="navbar">
				<Link to="/" className="nav-brand">
					<img src="/logo.jpg" alt={INFO.main.name} className="nav-brand-logo" />
					<div className="nav-brand-text">
						<span className="nav-brand-name">{INFO.main.name}</span>
						<span className="nav-brand-role">Software Engineer</span>
					</div>
				</Link>

				<button 
					className="mobile-menu-toggle" 
					onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
					aria-label="Toggle Navigation Menu"
				>
					{mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
				</button>

				<ul className={`nav-list ${mobileMenuOpen ? "open" : ""}`}>
					<li className={currentActive === "home" ? "nav-item active" : "nav-item"}>
						<Link to="/" onClick={() => setMobileMenuOpen(false)}>
							<Home size={15} />
							<span>Home</span>
						</Link>
					</li>
					<li className={currentActive === "about" ? "nav-item active" : "nav-item"}>
						<Link to="/about" onClick={() => setMobileMenuOpen(false)}>
							<User size={15} />
							<span>About</span>
						</Link>
					</li>
					<li className={currentActive === "projects" ? "nav-item active" : "nav-item"}>
						<Link to="/projects" onClick={() => setMobileMenuOpen(false)}>
							<Briefcase size={15} />
							<span>Projects</span>
						</Link>
					</li>
					<li className={currentActive === "articles" ? "nav-item active" : "nav-item"}>
						<Link to="/articles" onClick={() => setMobileMenuOpen(false)}>
							<FileText size={15} />
							<span>Articles</span>
						</Link>
					</li>
					<li className={currentActive === "contact" ? "nav-item active" : "nav-item"}>
						<Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
							<Mail size={15} />
							<span>Contact</span>
						</Link>
					</li>
				</ul>
			</nav>
		</header>
	);
};

export default NavBar;
